/** Images accepted by rich text fields and wiki pages. Kept free of editor imports so pure helpers can be unit-tested. */
export const RICH_TEXT_IMAGE_MIMES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
export const RICH_TEXT_IMAGE_MAX_BYTES = 10_485_760;

/** Why a dropped or pasted file cannot be uploaded as an image, or null when it can. */
export function rejectImageFile(file: { type: string; size: number }): string | null {
  if (!RICH_TEXT_IMAGE_MIMES.includes(file.type)) return 'Only PNG, JPEG, GIF and WebP images can be uploaded.';
  if (file.size > RICH_TEXT_IMAGE_MAX_BYTES) {
    return `Images must be under ${Math.round(RICH_TEXT_IMAGE_MAX_BYTES / 1_048_576)} MB.`;
  }
  return null;
}

type TransferItem = { kind: string; getAsFile: () => File | null };
type TransferLike = {
  files?: ArrayLike<File>;
  items?: ArrayLike<TransferItem>;
};

/**
 * Screenshot paste often puts the PNG on `items` and leaves `files` empty.
 * Prefer files, then fall back to file-kind items.
 */
export function imageFilesFromTransfer(data: TransferLike | null | undefined): File[] {
  if (!data) return [];
  const seen = new Set<File>();
  const out: File[] = [];
  function add(file: File | null): void {
    if (!file || seen.has(file) || rejectImageFile(file)) return;
    seen.add(file);
    out.push(file);
  }
  for (const file of Array.from(data.files ?? [])) add(file);
  for (const item of Array.from(data.items ?? [])) {
    if (item.kind === 'file') add(item.getAsFile());
  }
  return out;
}
